/*
 * @Author: Eugene
 * @Date: 2020-04-13 19:58:43
 * @Last Modified by: Eugene
 * @Last Modified time: 2021-05-18 10:46:47
 */
import { message } from 'antd';
import {
  getLiveClassList,
  createLiveClass,
  editLiveClass,
  getLiveClassInfo,
  deleteLiveClass,
  changeLiveClassStatus,
  listCoach,
  getLiveClassStatisticsInfo,
  queryClassDetailList,
  getCancelReason,
  liveStart,
  endLive,
  cancelLiveClass,
  getLiveChannelEnableList,
  getClassStreamUrl,
  getStreamStatus,
} from '@/services/live';
import { qiniuToken, uploadToQiniu } from '@/services/qiNiu/qiNiu';
import { history } from 'umi';
import moment from 'moment';

export default {
  namespace: 'liveState',

  state: {
    dataSource: [],
    classTypeList: [],
    coachList: [],
    channelList: [],
    cancelReason: {},
    pageData: {},
    data: { classDto: {} },
    pagination: {
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total) => `共 ${total} 条`,
    },
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const res = yield call(getLiveClassList, payload);
      if (res.result.code === '00000') {
        yield put({
          type: 'fetchSuccess',
          payload: {
            dataSource: res.result.data,
            pagination: {
              current: res.result.page.currentPage,
              pageSize: res.result.page.pageSize,
              total: res.result.page.count,
            },
          },
        });
      } else {
        message.error('获取直播课表失败！', 3);
      }
    },
    *fetchDetail({ payload }, { call, put }) {
      const res = yield call(getLiveClassInfo, payload);
      if (res.result.code === '00000') {
        res.result.data.time = [
          moment(res.result.data.liveStartTime),
          moment(res.result.data.liveEndTime),
        ];

        // 获取详情教练信息
        const res2 = yield call(listCoach, {
          requestData: { coachId: res.result.data.showCoachId },
        });
        if (res2.result.code === '00000') {
          const coaches = res2.result.data.map((item) => ({
            value: `${item.coachId}`,
            key: `${item.coachId}`,
            label: `${item.nickname}-${item.realName}`,
          }));
          res.result.data.coaches = coaches;
        }
        // 获取详情教练账号信息
        const res3 = yield call(listCoach, {
          requestData: { coachId: res.result.data.coachAccount },
        });
        if (res3.result.code === '00000') {
          const coachAccounts = res3.result.data.map((item) => ({
            value: `${item.coachId}`,
            key: `${item.coachId}`,
            label: `${item.nickname}-${item.realName}`,
          }));
          res.result.data.coachAccounts = coachAccounts;
        }
        yield put({
          type: 'fetchDetailOk',
          payload: {
            pageData: res.result.data,
          },
        });
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *fetchClassTypeList(_, { call, put, select }) {
      const liveState = yield select((state) => state.liveState);
      if (liveState.classTypeList.length) return;
      const res = yield call(queryClassDetailList, {
        requestData: {
          classTypeIdList: [6],
        },
        page: {
          currentPage: 1,
          pageSize: 9999,
        },
      });
      if (res.result.code === '00000') {
        yield put({
          type: 'fetchClassTypeListOk',
          payload: {
            classTypeList: res.result.data,
          },
        });
      } else {
        message.error('课程分类获取失败', 3);
      }
    },
    *fetchChannelList(_, { call, put, select }) {
      // const liveState = yield select(state => state.liveState)
      // if (liveState.channelList.length) return
      const res = yield call(getLiveChannelEnableList, {});
      if (res.result.code === '00000') {
        yield put({
          type: 'fetchChannelListOk',
          payload: {
            channelList: res.result.data.map((item) => ({
              label: item.name,
              value: item.id,
            })),
          },
        });
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *fetchCoachList({ payload }, { call, put }) {
      const { requestData, resolve } = payload;
      const res = yield call(listCoach, {
        requestData,
        page: {
          currentPage: 1,
          pageSize: 20,
        },
      });
      if (res.result.code === '00000') {
        resolve(res);
        yield put({
          type: 'fetchCoachListOk',
          payload: {
            coachList: res.result.data.map((item) => ({
              key: `${item.coachId}`,
              label: `${item.nickname}-${item.realName}`,
            })),
          },
        });
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *getStreamStatus({ payload }, { call, put }) {
      const { requestData, resolve } = payload;
      const res = yield call(getStreamStatus, {
        requestData,
      });

      if (res.result.code === '00000' && res.result.data == 1) {
        resolve(res.result.data);
      } else {
        resolve(res.result.data);
      }
    },
    *getCancelReason({ payload }, { call, put }) {
      const { requestData } = payload;
      const res = yield call(getCancelReason, {
        requestData,
      });
      if (res.result.code === '00000') {
        yield put({
          type: 'getCancelReasonOk',
          payload: {
            cancelReason: res.result.data,
          },
        });
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *cancelLiveClass({ payload }, { call, put }) {
      const { requestData, resolve } = payload;
      const res = yield call(cancelLiveClass, {
        requestData,
      });
      if (res.result.code === '00000') {
        message.success('操作成功', 3);
        resolve(res);
        yield put({
          type: 'fetch',
          payload: {
            requestData: {},
            page: { currentPage: 1, pageSize: 10 },
          },
        });
        // yield put(
        //   history.push({
        //     pathname: '/live/list',
        //     query: {
        //       ...payload.query,
        //     },
        //   }),
        // );
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *liveStart({ payload }, { call, put }) {
      const { requestData, other, resolve } = payload;
      const res = yield call(liveStart, {
        requestData,
        ...other,
      });

      if (res.result.code === '00000') {
        resolve(res);
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *endLive({ payload }, { call, put }) {
      const { requestData, other, resolve } = payload;
      const res = yield call(endLive, {
        requestData,
        ...other,
      });

      if (res.result.code === '00000') {
        resolve(res);
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *createLiveClass({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(createLiveClass, { requestData });
      if (res.result.code === '00000') {
        message.success('新增课程成功', 3);
        resolve(res);
      } else {
        resolve('error');
        message.error(`新增课程失败：${res.result.msg}`, 3);
      }
    },
    *editLiveClass({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(editLiveClass, { requestData });
      if (res.result.code === '00000') {
        message.success('更新课程成功', 3);
        resolve(res);
      } else {
        resolve('error');
        message.error(`更新课程失败：${res.result.msg}`, 3);
      }
    },
    *deleteLiveClass({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(deleteLiveClass, { requestData });
      if (res.result.code === '00000') {
        message.success('删除成功', 3);
        resolve(res);
      } else {
        message.error(`删除失败：${res.result.msg}`, 3);
      }
    },
    *getClassStreamUrl({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(getClassStreamUrl, { requestData });
      if (res.result.code === '00000') {
        resolve(res);
      } else {
        message.error(`获取推动地址失败：${res.result.msg}`, 3);
      }
    },
    *changeLiveClassStatus({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const text = status === 1 ? '下架' : '上架';
      const res = yield call(changeLiveClassStatus, { requestData });
      if (res.result.code === '00000') {
        resolve(res);
      } else {
        message.error(`${text}失败：${res.result.msg}`, 3);
      }
    },
    *upload({ payload }, { call, put, select }) {
      const { file } = payload;
      const liveState = yield select((state) => state.liveState);
      const { pageData } = liveState;
      const qiniuRes = yield call(qiniuToken);
      const res = yield call(uploadToQiniu, file, qiniuRes);
      if (res.key) {
        const imgUrl = `https://img.leoao.com/${res.key}`;
        yield put({
          type: 'fetchDetailOk',
          payload: {
            pageData: {
              ...pageData,
              defaultImg: imgUrl,
            },
          },
        });
      }
    },
    *fetchData({ payload }, { call, put }) {
      const res = yield call(getLiveClassStatisticsInfo, payload);
      if (res.result.code === '00000') {
        yield put({
          type: 'fetchDataOk',
          payload: {
            data: res.result.data,
          },
        });
      } else {
        message.error(res.result.msg, 3);
      }
    },
  },

  reducers: {
    fetchSuccess(state, action) {
      const { dataSource, pagination } = action.payload;
      return {
        ...state,
        dataSource,
        pagination: {
          ...state.pagination,
          ...pagination,
        },
      };
    },
    fetchDetailOk(state, action) {
      const { pageData } = action.payload;
      return {
        ...state,
        pageData,
      };
    },
    fetchDataOk(state, action) {
      const { data } = action.payload;
      return {
        ...state,
        data,
      };
    },
    fetchClassTypeListOk(state, action) {
      const { classTypeList } = action.payload;
      return {
        ...state,
        classTypeList,
      };
    },
    fetchChannelListOk(state, action) {
      const { channelList } = action.payload;
      return {
        ...state,
        channelList,
      };
    },
    fetchCoachListOk(state, action) {
      const { coachList } = action.payload;
      return {
        ...state,
        coachList,
      };
    },
    getCancelReasonOk(state, action) {
      const { cancelReason } = action.payload;
      return {
        ...state,
        cancelReason,
      };
    },
  },
};
